import { createContext } from "react";
const Modal = createContext();
const Confirm = createContext();
const Cart = createContext();
const Profile = createContext();
const General = createContext();
const Context = { Modal, Confirm, Cart, Profile, General };
export default Context;
